import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CollectionPurposeDataProvider } from "../../data-provider/collection-purpose.dp";
import { DataRecordDataProvider } from "../../data-provider/data-record.dp";
import { DataRecordHelper } from "../data-record/data-record.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { Campaign } from "../../models/campaign.model";
import { Effort } from "../../models/effort.model";
import { Feature } from "../../models/feature.model";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { Utils } from "../../helper/utils.helper";
import { DefaultDialogs } from "../../helper/default-dialogs.helper";

let CampaignInfo = {
    selector: "vcCampaignInfo",
    templateUrl: "/angular/components/profile/campaign-info.component.html",
    bindings: {},
    controller: class CampaignInfoController {
        public campaign: Campaign;
        public campaignid: string;
        public applications: any[] = [];
        public isOrganisationCampaign = false;
        public consentSettings: any = null;
        public securitySettings: any = null;
        public showSecurityTab = false;
        public notAllowed = false;
        public datapoints: any;
        public activeUser: User;
        public campaigns: Campaign[];
        public datarecordlog: any;
        public efforts: Effort[];
        public maxPermission: number;
        public ownerinfo: any;
        public officerinfo: any;
        public authorizedApps: any;
        public createdApps: any;
        private $scope: any;
        private $window: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private defaultDialogs: DefaultDialogs;
        public __env: any;

        public permissionProvider: PermissionCheck;
        private campaignDataProvider: CampaignDataProvider;
        private dataRecordDataProvider: DataRecordDataProvider;
        private dataRecordHelper: DataRecordHelper;

        constructor(
            $scope: any,
            $window: any,
            $cookies: any,
            __env: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            EffortDataProvider: EffortDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            CollectionPurposeDataProvider: CollectionPurposeDataProvider,
            DataRecordDataProvider: DataRecordDataProvider,
            UserDataProvider: UserDataProvider,
            DataRecordHelper: DataRecordHelper,
            Utils: Utils,
            DefaultDialogs: DefaultDialogs
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.defaultDialogs = DefaultDialogs;
            this.__env = __env;
            this.permissionProvider = PermissionCheck;
            this.campaignDataProvider = CampaignDataProvider;
            this.dataRecordDataProvider = DataRecordDataProvider;
            this.dataRecordHelper = DataRecordHelper;

            Utils.accessCheck();
            this.campaign = CampaignDataProvider.getActiveCampaign();
            this.campaignid = this.campaign.campaignid;

            CollectionPurposeDataProvider.points().then(
                (points: Array<any>) => {
                    this.datapoints = points;
                }
            );

            UserDataProvider.getUser($cookies.get("uid")).then((user: User) => {
                this.activeUser = user;
            });
            this.campaignDataProvider
                .allCampaigns()
                .then((campaigns: Campaign[]) => {
                    this.campaigns = campaigns;
                });
            this.dataRecordDataProvider
                .getAllDataRecords()
                .then((datarecordlog: any) => {
                    this.datarecordlog = datarecordlog;
                });
            EffortDataProvider.getAllEfforts().then((efforts: Effort[]) => {
                this.efforts = efforts;
            });
            this.campaignDataProvider
                .isOrganisationCampaign(this.campaignid)
                .then((isOrgCampaign: boolean) => {
                    this.isOrganisationCampaign = isOrgCampaign;
                    if (this.isOrganisationCampaign) this.maxPermission = 7;
                });
            this.campaignDataProvider
                .info(this.campaignid)
                .then((campaign: Campaign) => {
                    this.ownerinfo = campaign.relationships.owner.data;
                    this.permissionProvider
                        .getConsentSettings()
                        .then((consentSettings: any) => {
                            this.consentSettings = consentSettings;
                        });
                    this.permissionProvider
                        .getSecuritySettings()
                        .then((securitySettings: any) => {
                            this.securitySettings = securitySettings;
                        });
                });
            CollectionPurposeDataProvider.getOfficer().then((officer: any) => {
                if (angular.isDefined(officer)) {
                    this.officerinfo = officer;
                }
            });
        }

        featurePermissionDisabled(
            feature: Feature,
            featurePermissionID: string
        ): boolean {
            return feature.disabled(
                this.permissionProvider.permissionid,
                featurePermissionID
            );
        }

        openDataRecord($event: any): void {
            $event.stopPropagation();
            this.dataRecordHelper.openDataRecord(true, false);
        }

        getDataRecordURL($event: any, id: number): void {
            $event.preventDefault();
            $event.stopPropagation();
            this.dataRecordDataProvider
                .getDataRecordURL(id)
                .then((datarecordlink: any) => {
                    window.open(datarecordlink);
                });
        }

        openUpdateCampaign(campaign: Campaign, $event: any): void {
            let parentEl = angular.element(document.body);
            this.dialog
                .show({
                    parent: parentEl,
                    component: "vc-edit-campaign",
                    targetEvent: $event,
                    scope: this.$scope,
                    locals: {
                        campaign: _.cloneDeep(campaign),
                    },
                    ariaLabel: `Edit {{ ${this.__env.strings.campaign} | capitalize }}`,
                })
                .then((thisCampaign: Campaign) => {
                    _.merge(campaign, thisCampaign);
                });
        }

        deleteCampaignDialog(campaign: Campaign, ev: any): void {
            if (this.permissionProvider.hasStripeSubscription) {
                this.$window.location = "/#/cancel/" + campaign.campaignid;
            } else {
                this.defaultDialogs.contactSupport(
                    "Cancel subscription",
                    "canceling account",
                    ev
                );
            }
        }

        openBillingContacts(ev: any): void {
            this.dialog.show({
                component: "vc-billing-contacts",
                targetEvent: ev,
                scope: this.$scope,
                locals: {},
                ariaLabel: "Billing Admin",
                class: "profilecard",
                clickOutsideToClose: true,
                skipHide: true,
            });
        }

        showSecuritySettingsInfo($event: any): void {
            $event.stopPropagation();
            let openInfoModal = this.dialog
                .confirm()
                .title("Two-factor authentication")
                .htmlContent(
                    '<p style="max-width: 500px">' +
                        "Two-factor authentication is an enhanced security measure. Once enabled, users will be required to give two types of identification when they log in to Ecanvasser.<br/><br/>" +
                        '<a href="https://support.ecanvasser.com/en/articles/4911238-set-up-two-factor-authentication-for-your-ecanvasser-login" class="md-primary" target="_blank">Learn more</a></p>'
                )
                .ok("OK");
            this.dialog.showPreConfiguredDialog(openInfoModal);
        }

        openChangePlanDialog(ev: any): void {
            if (this.permissionProvider.hasStripeSubscription) {
                this.dialog.show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: "change",
                    },
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                });
            } else {
                this.defaultDialogs.contactSupport(
                    "Upgrade subscription",
                    "creating additional accounts",
                    ev
                );
            }
        }

        openPrivacyDashboard(): void {
            this.$window.location = "/#/privacy";
        }
    },
};

angular.module("profile").component(CampaignInfo.selector, CampaignInfo);
